import React, { useState } from 'react'
import Input from './Input'
import { CREATE_TUTOR } from '../redux/tutorReducer'
import { useDispatch } from 'react-redux'
interface Props {
  toggleModal: () => void
}

const CreateTutorModal = ({ toggleModal }: Props) => {
  const dispatch = useDispatch()
  const [firstName, setFirstName] = useState<string>('')
  const [lastName, setLastName] = useState<string>('')
  const [email, setEmail] = useState<string>('')

  const createTutor = () => {
    if (!firstName || !lastName || !email) return
    dispatch(CREATE_TUTOR({ first_name: firstName, last_name: lastName, email }))
    toggleModal()
  }

  return (
    <div>
      <div className="h-20" />
      <div className="bg-white rounded-md p-4 max-w-[27rem] w-screen">
        <h2 className="text-24 font-semibold">Create New Tutor</h2>
        <div className="flex flex-col gap-4 mt-4">
          <Input
            label="First Name"
            bgColor="white"
            color="darkIceBlue"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
          <Input
            label="Last Name"
            bgColor="white"
            color="darkIceBlue"
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
          <Input
            label="Email"
            bgColor="white"
            color="darkIceBlue"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="flex justify-end mt-4">
          <button onClick={createTutor} className="bg-slateGray px-4 py-2 rounded-md text-white font-semibold">
            Create Tutor
          </button>
        </div>
      </div>
    </div>
  )
}

export default CreateTutorModal
